module.exports = __webpack_public_path__ + "static/media/19_My Account_Change Password.3c476ef1.jpg";